import React  from 'react';
import { connect } from 'react-redux';

const SelectCinemap = props => {
    const { handleValueChanged, values } = props;

    const showValues = value => {
        return <option key={value.id} value={value.id}>{value.value}</option>
    };
    return (
        <div>
            <select className="select-date" onChange={handleValueChanged}>
                {values.map(showValues)}
            </select>
        </div>
    );
};

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(SelectCinemap);



// WEBPACK FOOTER //
// ./src/SHARED/components/select/select.component.js